<selected-filters
  [selectedFilters]="selectedFilters"
  (removeFilter)="removeFilter($event)"
>
</selected-filters>
<div class="btn-filter">
  <action-button
    class="btn-search"
    (actionEvent)="search($event)"
    label="{{ 'headerFilters.searchButton' | translate }}"
    labelPosition="after"
    [ngClass]="'btn-search'"
  >
    <mat-icon>search</mat-icon>
    <!-- Ícone de lupa -->
  </action-button>

  <filter-buttons
    (addFilter)="goToFilterPalette()"
    (clearFilters)="clearAllFilters()"
  >
  </filter-buttons>
</div>
